import React from 'react'
import Suspense from 'components/Suspense'
import SuspensePlaceholder from 'components/SuspensePlaceholder'
import PageContent from 'components/Layouts/V3/PageContent'
import PageLoadingIndicator from 'components/Layouts/V3/PageLoadingIndicator'
import useStyles from './styles'

export interface IPageBodyProps {
  children?: React.ReactNode
}

function PageBody(props: IPageBodyProps) {
  const { classes } = useStyles()
  const { children } = props

  return (
    <div className={classes.container}>
      <Suspense
        fallback={<PageLoadingIndicator />}
        ErrorFallbackComponent={errorProps => (
          <PageContent>
            <SuspensePlaceholder {...errorProps} raised={false} flat />
          </PageContent>
        )}
      >
        {children}
      </Suspense>
    </div>
  )
}

export default PageBody
